import { render, staticRenderFns } from "./ProposeEventView.vue?vue&type=template&id=ccd2825a&scoped=true&"
import script from "./ProposeEventView.vue?vue&type=script&lang=js&"
export * from "./ProposeEventView.vue?vue&type=script&lang=js&"
import style0 from "./ProposeEventView.vue?vue&type=style&index=0&id=ccd2825a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd2825a",
  null
  
)

export default component.exports